import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function WachtwoordHerstellen() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Wachtwoord minimaal 6 tekens"); return; }
    if (pw !== pw2) { toast.error("Wachtwoorden komen niet overeen"); return; }
    setBusy(true);
    try {
      await api.post("/auth/wachtwoord-herstellen", { token, wachtwoord: pw });
      toast.success("Wachtwoord ingesteld — log in met je nieuwe wachtwoord");
      navigate("/login");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Herstellen mislukt");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Card className="w-full max-w-md border-border shadow-none" data-testid="wachtwoord-herstellen-card">
        <CardHeader>
          <CardTitle className="font-display text-3xl">Nieuw wachtwoord</CardTitle>
          <CardDescription>Stel een nieuw wachtwoord in voor je account.</CardDescription>
        </CardHeader>
        <CardContent>
          {!token ? (
            <div className="text-sm text-muted-foreground" data-testid="herstellen-geen-token">
              Geen geldige herstellink. Vraag een nieuwe aan via "Wachtwoord vergeten".
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="pw">Nieuw wachtwoord</Label>
                <Input id="pw" type="password" required data-testid="herstellen-pw"
                  value={pw} onChange={(e) => setPw(e.target.value)} placeholder="min. 6 tekens" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="pw2">Herhaal wachtwoord</Label>
                <Input id="pw2" type="password" required data-testid="herstellen-pw2"
                  value={pw2} onChange={(e) => setPw2(e.target.value)} />
              </div>
              <Button type="submit" className="w-full h-11" disabled={busy} data-testid="herstellen-submit">
                {busy ? "Bezig…" : "Wachtwoord instellen"}
              </Button>
            </form>
          )}
          <Link to="/login" className="mt-5 inline-flex items-center gap-1 text-sm text-primary hover:underline">
            <ArrowLeft className="h-3.5 w-3.5" /> Terug naar inloggen
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
